import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../core';
import { FormBuilder, Validators } from '@angular/forms';
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

declare var Intercom: any;
@Component({
  selector: 'app-new-footer',
  templateUrl: './new-footer.component.html',
  styleUrls: ['./new-footer.component.scss']
})
export class NewFooterComponent implements OnInit {
  public subscribeEmail: string;
  sform: any;
  submitted = false;
  suscribeError = false;
  cansubmit = true;
  public submitBtnText: string;
  faLinkedin = faLinkedin;
  faFacebook = faFacebook;
  faInstagram = faInstagram;

  constructor(private router: Router, private httpService: HttpService, private fb: FormBuilder) {
    this.sform = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(/^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/)]]
    });
    this.submitBtnText = ' Subscribe ';

  }
  ngOnInit(): void {
  }

  get f() {
    return this.sform.controls;
  }


  toYepDeveloper() {
    if (this.router.url.indexOf('/auth/home') === -1) {
      this.router.navigate(['/auth/home'], { queryParams: { to: 'developer' } });
    }
    else {
      (window as any).moveToDeveloper();
    }
  }
  toYepAgent() {
    if (this.router.url.indexOf('/auth/home') === -1) {
      this.router.navigate(['/auth/home'], { queryParams: { to: 'agent' } });
    }
    else {
      (window as any).moveToAgent();
    }
  }
  toContact() {
    Intercom('showNewMessage');
  }
  toLinkedin() {
    window.open('https://www.linkedin.com/company/yep-innovation-pty-ltd/');
  }
  toFacebook() {
    window.open('https://www.facebook.com/yephome.io');
  }
  toIns() {
    window.open('https://www.instagram.com/yephome.io/?hl=en');
  }
  toPrivacy() {
    window.open('https://www.yephome.com.au/privacy');
  }
  toTerms() {
    window.open('https://www.yephome.com.au/terms');
  }
  toYepIo() {
    window.open('https://www.yephome.com.au/');
  }

  // 去掉前后空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }

  handleToSave() {
    this.submitted = true;
    if (this.sform.invalid) {
      return;
    }
    const fd = new FormData();

    fd.append('email', this.trim(this.subscribeEmail));
    this.httpService.saveEmail(fd).subscribe((res) => {
      this.submitted = false;
      this.suscribeError = false;
      // this.subscribeEmail = '';
      this.cansubmit = false;
      this.submitBtnText = ' Subscribed Successfully ';
    }, (err) => {
      this.suscribeError = true;
      this.submitted = false;
      this.cansubmit = false;
      this.submitBtnText = '  Subscribed Faild ';
    });
  }

  subscrbeChange() {
    this.submitBtnText = '  Subscribe  ';
    this.suscribeError = false;
    this.cansubmit = true;
  }
}